import axios from '../../axios'
// import {apiConstants} from "constants/apiConstants";
const URL = {
  // getInformationList:'learn/app/clientapi/home/ai/info/pageInfoList.do'
  getInformationList: 'learn/app/clientapi/home/info/queryByPage.do',
}
export default {
  /**
   * 频道资讯列表
   */
  queryCourseListAll: (pageNo: number, homeId: string) => {
    return axios.get(URL.getInformationList, {
      params: {
        // isSupportAudioLive:1,
        pageNo,
        pageSize: 30,
        homeId,
        // ver: apiConstants.VER,
      },
    })
  },
}
